// import React, { useEffect, useRef, useState } from "react";
// import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
// import { Disc, X, Power } from "react-feather";
// import userAvatar from "../assets/images/profile.webp";
// import {
//   sideMenu,
//   ClientMenu,
//   superAdminsideMenu,
//   StaffSideMenu,
//   employeeSideMenu,
// } from "../constants/SideMenu";
// import { useSelector, useDispatch } from "react-redux";
// import Cookies from "universal-cookie";
// import { setUserInfo, setUserToken } from "../redux/authSlice";


// const cookies = new Cookies();

// function Sidebar() {
//   const shadowRef = useRef(null);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const userInfo = useSelector((state) => state?.authState.userInfo);

//   // console.log("userInfo", userInfo);

//   const [clientSideMenu, setClientSideMenu] = useState(ClientMenu);
//   const [superAdminMenu, setSuperAdminMenu] = useState(superAdminsideMenu);
//   const [staffMenu, setStaffMenu] = useState(StaffSideMenu);
//   const [employeeMenu, setEmployeeMenu] = useState(employeeSideMenu);
//   const [menu, setMenu] = useState(sideMenu);
//   const [hover, setHover] = useState(false);

//   const scrollMenu = (container) => {
//     if (shadowRef && container.scrollTop > 0) {
//       shadowRef.current.classList.add("d-block");
//     } else {
//       shadowRef.current.classList.remove("d-block");
//     }
//   };

//   const onCollapseClick = (e, item) => {
//     e.preventDefault();
//     const resMenu = menu?.map((sm) =>
//       sm.label === item.label ? { ...sm, isActive: !item.isActive } : sm
//     );
//     setMenu(resMenu);
//   };

//   useEffect(() => {
//     const matchPath = (menuList) => {
//       if (menuList?.some((sm) => sm.to === location.pathname)) {
//         return menuList?.map((sm) =>
//           sm.to === location.pathname ? { ...sm, isActive: true } : sm
//         );
//       } else if (
//         menuList?.some((sm) =>
//           sm?.children?.some((smc) => smc.to === location.pathname)
//         )
//       ) {
//         return menuList?.map((sm) =>
//           sm?.children?.some((smc) => smc.to === location.pathname)
//             ? { ...sm, isActive: true }
//             : sm
//         );
//       }
//       return menuList;
//     };

//     if (userInfo?.role === "admin") {
//       setClientSideMenu(matchPath(ClientMenu));
//     } else if (userInfo?.role === "staff") {
//       setStaffMenu(matchPath(StaffSideMenu));
//     } else {
//       setMenu(matchPath(sideMenu));
//     }
//   }, [location]);

//   const menuCollapse = () => {
//     document.querySelector(".main-menu").classList.add("collapse");
//     document.querySelector(".main-menu").classList.remove("expanded");
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     cookies.remove("MMCL");
//     cookies.remove("MMCL_user");
//     cookies.remove("isLoggedIn");
//     dispatch(setUserInfo({}));
//     dispatch(setUserToken(""));
//     navigate("/");
//   };

//   const renderMenuItems = (menuList) => {
//     return menuList?.map((sm, i) => {
//       if (sm?.children) {
//         return (
//           <li
//             key={i}
//             className={`nav-item has-sub ${sm?.isActive
//                 ? "open menu-collapsed-open sidebar-group-active"
//                 : ""
//               }`}
//           >
//             <Link
//               className="d-flex align-items-center"
//               to="#"
//               onClick={(e) => onCollapseClick(e, sm)}
//             >
//               {sm?.icon}
//               <span className="menu-title text-truncate">{sm.label}</span>
//             </Link>
//             <ul className="menu-content">
//               <div className={`collapse ${sm.isActive ? "show" : ""}`}>
//                 {sm?.children?.map((smc, j) => (
//                   <li className="nav-item" key={j}>
//                     <NavLink to={smc?.to}>
//                       {smc?.icon}
//                       {smc?.label}
//                     </NavLink>
//                   </li>
//                 ))}
//               </div>
//             </ul>
//           </li>
//         );
//       } else {
//         return (
//           <li className="nav-item" key={i}>
//             <NavLink to={sm?.to}>
//               {sm?.icon}
//               {sm.label}
//             </NavLink>
//           </li>
//         );
//       }
//     });
//   };

//   return (
//     <div className="main-menu menu-fixed   d-flex flex-column menu-accordion menu-shadow expanded menu-light">
//       <div className="navbar-header">
//         <ul className="nav navbar-nav flex-row">
//           <li className="nav-item me-auto">
//             <div className="brand-text-container navbar-brand d-flex align-items-center">
//               {userInfo.role !== "employee" && (
//                 <Link
//                   to="/dashboard"
//                   style={{ textDecoration: "none", color: "inherit" }}
//                 >
//                   <h2
//                     className="brand-text mb-0"
//                     style={{ fontSize: "18px", fontWeight: "bold" }}
//                   >
//                     CMS | XAVA
//                   </h2>
//                 </Link>
//               )}

//               {userInfo.role === "employee" && (
//                 <h2
//                   className="brand-text mb-0"
//                   style={{ fontSize: "18px", fontWeight: "bold" }}
//                 >
//                   CMS | XAVA
//                 </h2>
//               )}

//             </div>
//           </li>
//           <li className="nav-item nav-toggle">
//             <div className="nav-link modern-nav-toggle cursor-pointer">
//               <X
//                 className="toggle-icon icon-x d-block d-xl-none"
//                 onClick={menuCollapse}
//                 size={20}
//               />
//             </div>
//           </li>
//         </ul>
//       </div>

//       <div className="shadow-bottom" ref={shadowRef}></div>

//       <ul className="navigation navigation-main">
//         {userInfo?.role === "admin" && renderMenuItems(clientSideMenu)}
//         {userInfo?.role === "staff" && renderMenuItems(staffMenu)}
//         {userInfo?.role === "employee" && renderMenuItems(employeeMenu)}
//         {userInfo?.role !== "admin" &&
//           userInfo?.role !== "staff" &&
//           userInfo?.role !== "employee" &&
//           renderMenuItems(menu)}
//       </ul>

//       {/* Avatar + Logout Section (Bottom) */}
//       <div className="sidebar-user px-2 py-2 mt-auto d-flex align-items-center justify-content-between border-top">
//         <div className="d-flex align-items-center">
//           <img
//             src={userInfo?.profilePicUrl || userAvatar}
//             height="40"
//             width="40"
//             className="rounded-circle me-1"
//             alt="avatar"
//           />
//           <div className="d-flex flex-column">
//             <span className="fw-bold text-capitalize">
//               {userInfo?.fname} {userInfo?.lname}
//             </span>
//             <small className=" fw-bold text-capitalize">{userInfo?.role}</small>
//             {/* {userInfo?.role === "admin" && ( */}
//             <>
//               <Link
//                 to="/accountsettings"
//                 className="text-muted"
//                 style={{
//                   fontSize: "0.8rem",
//                   textDecoration: hover ? "underline" : "none",
//                   color: hover ? "#5e5873" : "#6c757d", // optional color change
//                   cursor: "pointer",
//                 }}
//                 onMouseEnter={() => setHover(true)}
//                 onMouseLeave={() => setHover(false)}
//               >
//                 Account Settings
//               </Link>
//             </>
//             {/* )} */}
//           </div>
//         </div>
//         <Power
//           className="cursor-pointer text-danger"
//           size={18}
//           onClick={handleLogout}
//         />
//       </div>
//     </div>
//   );
// }

// export default Sidebar;






// import React, { useEffect, useRef, useState } from "react";
// import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
// import { Disc, X, Power, Camera } from "react-feather";
// import userAvatar from "../assets/images/avatar-s-11.jpg";
// import { sideMenu, ClientMenu, superAdminsideMenu, StaffSideMenu, employeeSideMenu } from "../constants/SideMenu";
// import { useSelector, useDispatch } from "react-redux";
// import Cookies from "universal-cookie";
// import { setUserInfo, setUserToken } from "../redux/authSlice";

// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
// import { useLogofileUploadMutation } from "../service";
// import { toast } from "react-hot-toast";

// const cookies = new Cookies();

// function Sidebar() {
//   const shadowRef = useRef(null);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const userInfo = useSelector((state) => state?.authState.userInfo);

//   const [clientSideMenu, setClientSideMenu] = useState(ClientMenu);
//   const [superAdminMenu, setSuperAdminMenu] = useState(superAdminsideMenu);
//   const [staffMenu, setStaffMenu] = useState(StaffSideMenu);
//   const [employeeMenu, setEmployeeMenu] = useState(employeeSideMenu);
//   const [menu, setMenu] = useState(sideMenu);
//   const [hover, setHover] = useState(false);

//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [previewImage, setPreviewImage] = useState("");

//   const [logofileUpload, { isLoading }] = useLogofileUploadMutation();

//   const scrollMenu = (container) => {
//     if (shadowRef && container.scrollTop > 0) {
//       shadowRef.current.classList.add("d-block");
//     } else {
//       shadowRef.current.classList.remove("d-block");
//     }
//   };

//   const onCollapseClick = (e, item) => {
//     e.preventDefault();
//     const resMenu = menu?.map((sm) =>
//       sm.label === item.label ? { ...sm, isActive: !item.isActive } : sm
//     );
//     setMenu(resMenu);
//   };

//   useEffect(() => {
//     const matchPath = (menuList) => {
//       if (menuList?.some((sm) => sm.to === location.pathname)) {
//         return menuList?.map((sm) =>
//           sm.to === location.pathname ? { ...sm, isActive: true } : sm
//         );
//       } else if (menuList?.some((sm) => sm?.children?.some((smc) => smc.to === location.pathname))) {
//         return menuList?.map((sm) =>
//           sm?.children?.some((smc) => smc.to === location.pathname) ? { ...sm, isActive: true } : sm
//         );
//       }
//       return menuList;
//     };

//     if (userInfo?.role === "admin") {
//       setClientSideMenu(matchPath(ClientMenu));
//     } else if (userInfo?.role === "staff") {
//       setStaffMenu(matchPath(StaffSideMenu));
//     } else {
//       setMenu(matchPath(sideMenu));
//     }
//   }, [location]);

//   const menuCollapse = () => {
//     document.querySelector(".main-menu").classList.add("collapse");
//     document.querySelector(".main-menu").classList.remove("expanded");
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     cookies.remove("MMCL");
//     cookies.remove("MMCL_user");
//     cookies.remove("isLoggedIn");
//     dispatch(setUserInfo({}));
//     dispatch(setUserToken(""));
//     navigate("/");
//   };

//   const handleImageClick = () => {
//     setModalOpen(true);
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setSelectedFile(file);
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpload = async () => {
//     if (!selectedFile) {
//       toast.error("Please select an image.");
//       return;
//     }

//     const payload = {
//       createdBy: userInfo?._id,
//       file: selectedFile,
//       imagetype: "profile",
//       type: "image",
//       fileId: userInfo?._id,
//     };

//     try {
//       const response = await logofileUpload(payload).unwrap();

//       if (response?.data?.filePath) {
//         const newProfilePicUrl = response?.data?.filePath;

//         // Update Redux state (optional but recommended)
//         const updatedUser = { ...userInfo, profilePicUrl: newProfilePicUrl };
//         dispatch(setUserInfo(updatedUser));

//         toast.success("Profile picture updated!");
//         setModalOpen(false);
//       } else {
//         toast.error("Failed to update profile picture.");
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error("Something went wrong.");
//     }
//   };

//   const renderMenuItems = (menuList) => {
//     return menuList?.map((sm, i) => {
//       if (sm?.children) {
//         return (
//           <li key={i} className={`nav-item has-sub ${sm?.isActive ? "open menu-collapsed-open sidebar-group-active" : ""}`}>
//             <Link className="d-flex align-items-center" to="#" onClick={(e) => onCollapseClick(e, sm)}>
//               {sm?.icon}
//               <span className="menu-title text-truncate">{sm.label}</span>
//             </Link>
//             <ul className="menu-content">
//               <div className={`collapse ${sm.isActive ? "show" : ""}`}>
//                 {sm?.children?.map((smc, j) => (
//                   <li className="nav-item" key={j}>
//                     <NavLink to={smc?.to}>
//                       {smc?.icon}
//                       {smc?.label}
//                     </NavLink>
//                   </li>
//                 ))}
//               </div>
//             </ul>
//           </li>
//         );
//       } else {
//         return (
//           <li className="nav-item" key={i}>
//             <NavLink to={sm?.to}>
//               {sm?.icon}
//               {sm.label}
//             </NavLink>
//           </li>
//         );
//       }
//     });
//   };

//   return (
//     <div className="main-menu menu-fixed d-flex flex-column menu-accordion menu-shadow expanded menu-light">
//       <div className="navbar-header">
//         <ul className="nav navbar-nav flex-row">
//           <li className="nav-item me-auto">
//             <div className="brand-text-container navbar-brand d-flex align-items-center">
//               {userInfo.role !== "employee" ? (
//                 <Link to="/dashboard" style={{ textDecoration: "none", color: "inherit" }}>
//                   <h2 className="brand-text mb-0" style={{ fontSize: "18px", fontWeight: "bold" }}>
//                     CMS | XAVA
//                   </h2>
//                 </Link>
//               ) : (
//                 <h2 className="brand-text mb-0" style={{ fontSize: "18px", fontWeight: "bold" }}>
//                   CMS | XAVA
//                 </h2>
//               )}
//             </div>
//           </li>
//           <li className="nav-item nav-toggle">
//             <div className="nav-link modern-nav-toggle cursor-pointer">
//               <X className="toggle-icon icon-x d-block d-xl-none" onClick={menuCollapse} size={20} />
//             </div>
//           </li>
//         </ul>
//       </div>

//       <div className="shadow-bottom" ref={shadowRef}></div>

//       <ul className="navigation navigation-main">
//         {userInfo?.role === "admin" && renderMenuItems(clientSideMenu)}
//         {userInfo?.role === "staff" && renderMenuItems(staffMenu)}
//         {userInfo?.role === "employee" && renderMenuItems(employeeMenu)}
//         {userInfo?.role !== "admin" && userInfo?.role !== "staff" && userInfo?.role !== "employee" && renderMenuItems(menu)}
//       </ul>

//       <div className="sidebar-user px-2 py-2 mt-auto d-flex align-items-center justify-content-between border-top">
//         <div className="d-flex align-items-center" style={{ cursor: "pointer" }} onClick={handleImageClick}>
//           <div style={{ position: "relative" }}>
//             <img
//               src={userInfo?.profilePicUrl || userAvatar}
//               height="40"
//               width="40"
//               className="rounded-circle me-1"
//               alt="avatar"
//             />
//             <Camera size={14} style={{ position: "absolute", bottom: 0, right: 0 }} />
//           </div>
//           <div className="d-flex flex-column ms-1">
//             <span className="fw-bold text-capitalize">{userInfo?.fname} {userInfo?.lname}</span>
//             <small className="fw-bold text-capitalize">{userInfo?.role}</small>
//             {userInfo?.role === "admin" && (
//               <Link to="/accountsettings" className="text-muted" style={{ fontSize: "0.8rem" }}>
//                 Account Settings
//               </Link>
//             )}
//           </div>
//         </div>
//         <Power className="cursor-pointer text-danger" size={18} onClick={handleLogout} />
//       </div>

//       <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
//         <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Upload Profile Picture</ModalHeader>
//         <ModalBody>
//           {previewImage && <img src={previewImage} alt="Preview" style={{ width: "100%", marginBottom: "10px" }} />}
//           <input type="file" accept="image/*" onChange={handleFileChange} />
//         </ModalBody>
//         <ModalFooter>
//           <Button color="primary" onClick={handleUpload} disabled={isLoading}>
//             {isLoading ? "Uploading..." : "Upload"}
//           </Button>
//           <Button color="secondary" onClick={() => setModalOpen(false)}>
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </div>
//   );
// }

// // export default Sidebar;





import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Disc, X, Power, Settings, MapPin } from "react-feather";
import Menu from "react-feather/dist/icons/menu";

import userAvatar from "../assets/images/avatar-s-11.jpg";
import xavaLogo from "../assets/images/xava-logo.png";
import { homeRouteFor } from "../utils/homeRoute";
import MobileNav from "./MobileNav";
import {
  sideMenu,
  ClientMenu,
  superAdminsideMenu,
  StaffSideMenu,
  contractorSideMenu,
  employeeSideMenu,
} from "../constants/SideMenu";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "universal-cookie";
import { setUserInfo, setUserToken } from "../redux/authSlice";
import {
  useGetAllReimbursementsQuery,
  useGetAllProfileChangesQuery,
  useGetAllLeaveRequestsQuery,
  useGetAllAttendanceRequestsQuery,
  useGetAllTicketsQuery,
  useUpdateMyLocationMutation,
} from "../service";
import { captureLocation } from "../utils/captureLocation";
import { toast } from "react-hot-toast";


const cookies = new Cookies();

function Sidebar() {
  const shadowRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state?.authState.userInfo);
  const isReviewer = userInfo?.role === "admin" || userInfo?.role === "staff";
  const pollOpts = { skip: !isReviewer, pollingInterval: 60000 };
  const { data: sbReimb } = useGetAllReimbursementsQuery(undefined, pollOpts);
  const { data: sbProfile } = useGetAllProfileChangesQuery(undefined, pollOpts);
  const { data: sbLeaves } = useGetAllLeaveRequestsQuery(undefined, pollOpts);
  const { data: sbAtt } = useGetAllAttendanceRequestsQuery(undefined, pollOpts);
  const { data: sbTickets } = useGetAllTicketsQuery(undefined, pollOpts);
  const [updateMyLocation] = useUpdateMyLocationMutation();
  const [sharingLoc, setSharingLoc] = useState(false);
  const reshareLocation = async () => {
    setSharingLoc(true);
    try {
      const loc = await captureLocation();
      await updateMyLocation(loc).unwrap();
      try { sessionStorage.setItem("xv:locSent", "1"); } catch (e) {}
      toast.success(loc.city ? `Location updated: ${loc.city}` : "Location updated");
    } catch (e) {
      toast.error("Couldn't get your location. Check the browser's location permission");
    } finally {
      setSharingLoc(false);
    }
  };
  const approvalsPending =
    ((sbReimb?.data || []).filter((r) => r.status === "Under Review").length) +
    ((sbProfile?.data || []).filter((r) => r.status === "Pending").length);
  const peoplePending =
    ((sbLeaves || []).filter?.((r) => r.status === "Pending")?.length || 0) +
    ((sbAtt || []).filter?.((r) => r.approvalStatus === "Pending")?.length || 0);
  // Single source of truth for pending counts — the sidebar and the mobile
  // tab bar/sheet all read from this.
  const badgeCount = (to) => {
    if (!isReviewer) return 0;
    const ticketsOpen = (sbTickets?.data || []).filter((t) => t.status === "Open").length;
    return to === "/requests"
      ? approvalsPending
      : to === "/employeemanagement"
      ? peoplePending
      : to === "/tickets"
      ? ticketsOpen
      : 0;
  };
  const badgeLabel = (to) => {
    const n = badgeCount(to);
    return n > 0 ? (n > 9 ? "9+" : String(n)) : null;
  };
  const menuBadge = (to) => {
    const label = badgeLabel(to);
    return label ? <span className="xv-menu-badge">{label}</span> : null;
  };

  const [clientSideMenu, setClientSideMenu] = useState(ClientMenu);
  const [staffMenu, setStaffMenu] = useState(StaffSideMenu);
  const [employeeMenu, setEmployeeMenu] = useState(employeeSideMenu);
  const [contracorMenu, setContracorMenu] = useState(contractorSideMenu);
  const [menu, setMenu] = useState(sideMenu);
  const [hover, setHover] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const onCollapseClick = (e, item) => {
    e.preventDefault();
    const resMenu = menu?.map((sm) =>
      sm.label === item.label ? { ...sm, isActive: !item.isActive } : sm
    );
    setMenu(resMenu);
  };

  useEffect(() => {
    const matchPath = (menuList) => {
      if (menuList?.some((sm) => sm.to === location.pathname)) {
        return menuList?.map((sm) =>
          sm.to === location.pathname ? { ...sm, isActive: true } : sm
        );
      } else if (
        menuList?.some((sm) =>
          sm?.children?.some((smc) => smc.to === location.pathname)
        )
      ) {
        return menuList?.map((sm) =>
          sm?.children?.some((smc) => smc.to === location.pathname)
            ? { ...sm, isActive: true }
            : sm
        );
      }
      return menuList;
    };

    if (userInfo?.role === "admin") {
      setClientSideMenu(matchPath(ClientMenu));
    } else if (userInfo?.role === "staff") {
      setStaffMenu(matchPath(StaffSideMenu));
    } else if (userInfo?.role === "contractor") {
      setContracorMenu(matchPath(contracorMenu));
    }else if (userInfo?.role === "employee") {
      setEmployeeMenu(matchPath(employeeMenu));
    } else {
      setMenu(matchPath(sideMenu));
    }
  }, [location]);

  const handleLogout = () => {
    localStorage.clear();
    cookies.remove("MMCL");
    cookies.remove("MMCL_user");
    cookies.remove("isLoggedIn");
    dispatch(setUserInfo({}));
    dispatch(setUserToken(""));
    navigate("/");
  };

  // A menu item can declare `permission`. Admins see everything; anyone else
  // needs that permission (or blanket fullAccess) granted by the super admin.
  const canSee = (item) => {
    if (!item?.permission) return true;
    if (["admin", "superAdmin", "Super Admin"].includes(userInfo?.role)) return true;
    const perms = userInfo?.permissions || [];
    return perms.includes(item.permission) || perms.includes("fullAccess");
  };

  const renderMenuItems = (menuList) => {
    return menuList?.filter(canSee)?.map((sm, i) => {
      if (sm?.children) {
        return (
          <li
            key={i}
            className={`nav-item has-sub ${
              sm?.isActive
                ? "open menu-collapsed-open sidebar-group-active"
                : ""
            }`}
          >
            <Link
              className="d-flex align-items-center"
              to="#"
              onClick={(e) => onCollapseClick(e, sm)}
            >
              {sm?.icon}
              <span className="menu-title text-truncate">{sm.label}</span>
            </Link>
            <ul className="menu-content">
              <div className={`collapse ${sm.isActive ? "show" : ""}`}>
                {sm?.children?.map((smc, j) => (
                  <li className="nav-item" key={j}>
                    <NavLink to={smc?.to}>
                      {smc?.icon}
                      {smc?.label}
                    </NavLink>
                  </li>
                ))}
              </div>
            </ul>
          </li>
        );
      } else {
        return (
          <li className="nav-item" key={i}>
            <NavLink to={sm?.to}>
              {sm?.icon}
              {sm.label}
              {menuBadge(sm?.to)}
            </NavLink>
          </li>
        );
      }
    });
  };

  return (
    <>
      <MobileNav badgeFor={badgeLabel} />

      {/* Backdrop on mobile */}
      {isMobileOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            // just under the sidebar (1031) so the open drawer stays on top
            zIndex: 1030,
          }}
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Toggle button for mobile */}
      <div className="xv-legacy-toggle d-xl-none d-flex justify-content-between align-items-center px-2 py-1 border-bottom">
      {/* <div className="d-md-none d-flex justify-content-between align-items-center px-2 py-1 border-bottom"> */}
        <Menu
          className="cursor-pointer"
          size={24}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
        />
      </div>

      <div
  // className={`main-menu menu-fixed d-flex flex-column menu-accordion menu-shadow menu-light ${
  //   isMobileOpen ? "d-block" : "d-none"
  // } d-md-flex`}
  className={`main-menu menu-fixed d-flex flex-column menu-accordion menu-shadow menu-light ${isMobileOpen ? "d-block" : "d-none"} d-xl-flex`}

  style={{
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    // Must stay below Bootstrap's modal backdrop (1050) so open modals dim the
    // sidebar instead of the dialog sliding underneath a bright menu. 1031
    // matches the theme's own .main-menu z-index.
    zIndex: 1031,
    width: isMobileOpen ? "250px" : undefined,
  }}
>

        <div className="navbar-header">
          <ul className="nav navbar-nav flex-row">
            <li className="nav-item me-auto">
              <div className="navbar-brand xv-brand">
                <Link to={homeRouteFor(userInfo?.role)} className="xv-brand-chip">
                  <img src={xavaLogo} alt="Xava Web Services CRM" />
                </Link>
              </div>
            </li>
            <li className="nav-item nav-toggle">
              <div className="nav-link modern-nav-toggle cursor-pointer">
                <X
                  className="toggle-icon icon-x d-block d-xl-none"
                  onClick={() => setIsMobileOpen(false)}
                  size={20}
                />
              </div>
            </li>
          </ul>
        </div>

        <div className="shadow-bottom" ref={shadowRef}></div>

        {/* Scrollable navigation */}
        <ul
          className="navigation navigation-main"
          style={{ flex: 1, overflowY: "auto" }}
        >
          {userInfo?.role === "admin" && renderMenuItems(clientSideMenu)}
          {userInfo?.role === "staff" && renderMenuItems(staffMenu)}
          {userInfo?.role === "employee" && renderMenuItems(employeeMenu)}
          {userInfo?.role === "contractor" && renderMenuItems(contracorMenu)}
          {userInfo?.role !== "admin" &&
            userInfo?.role !== "staff" &&
            userInfo?.role !== "employee" &&
            renderMenuItems(menu)}
        </ul>

        <div className="sidebar-user xv-user-foot">
          <img
            src={userInfo?.profilePicUrl || userAvatar}
            className="xv-user-avatar"
            alt=""
          />
          <div className="xv-user-meta">
            <span className="xv-user-name text-capitalize">
              {userInfo?.fname} {userInfo?.lname}
            </span>
            <span className="xv-user-role text-capitalize">{userInfo?.role}</span>
          </div>
          {userInfo?.role === "employee" && (
            <button
              type="button"
              className="xv-user-btn"
              onClick={reshareLocation}
              disabled={sharingLoc}
              title="Share my location"
              aria-label="Share my location"
            >
              <MapPin size={16} />
            </button>
          )}
          {userInfo?.role !== "contractor" && (
            <Link
              to="/accountsettings"
              className="xv-user-btn"
              title="Account settings"
              aria-label="Account settings"
            >
              <Settings size={16} />
            </Link>
          )}
          <button
            type="button"
            className="xv-user-btn is-danger"
            onClick={handleLogout}
            title="Log out"
            aria-label="Log out"
          >
            <Power size={16} />
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
